<section class="breadcrumb">
    <div class="container">
        <div class="row no-gutter">
            <div class="col-md-12 breadcrumb-wrap">
                <p><a (click)="onHome()"><u>Home</u></a> <img src="./../../../assets/images/rightArrow.svg"> &nbsp;
                <a (click)="onMyorg()"><u>My Organizations</u></a> 
                <ng-container *ngIf="additionalMsg"><span class="addMsg"><img src="./../../../assets/images/rightArrow.svg"> &nbsp; {{additionalMsg}}</span></ng-container></p>
                <h2><ng-container *ngIf="!additionalHeader">{{title}}</ng-container> 
                    <ng-container *ngIf="additionalHeader"><span class="addMsg">{{additionalHeader}}</span></ng-container> 
                     <!-- {{additionalMsg ? '-': ''}} {{additionalMsg}} -->
                </h2>
            </div>
        </div>
    </div>
</section>
